import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import type { ReactNode } from 'react';

/**
 * Potwierdzenie w oknie aplikacji (zamiast okna przeglądarki). Akcje usuwające / nieodwracalne — czerwony przycisk.
 * Zwraca true po potwierdzeniu.
 */
export function ask(message: ReactNode, o: { title?: string; confirm?: string; danger?: boolean } = {}): Promise<boolean> {
  return new Promise((resolve) => {
    modals.openConfirmModal({
      title: o.title ?? 'Potwierdź',
      centered: true,
      children: typeof message === 'string' ? <Text size="sm">{message}</Text> : message,
      labels: { confirm: o.confirm ?? 'Tak', cancel: 'Anuluj' },
      confirmProps: { color: o.danger ? 'red' : undefined },
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false),
      onClose: () => resolve(false),
    });
  });
}
